import React, { useState } from 'react';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

function SelectPassengerModal() {
  const [profileName, setProfileName] = useState('');
  return (
    <div>
      <AppTextInput
        name="profileName"
        id="profileName"
        onChange={(e) => setProfileName(e.target.value)}
        value={profileName}
      />
    </div>
  );
}

export default SelectPassengerModal;
